import { AnimatePresence, motion } from "motion/react"
import { useEffect, useRef, useState } from "react"
import { Avatar } from "ui"

const feedbackData = [
    {
        id: 1,
        name: "Glitch here, looking for bugs!",
        comments: [
            "Running diagnostics... Looking for sneaky bugs hiding in the code!",
            "Checking for code inconsistencies and unexpected behavior.",
            "Bug hunt initiated! Seeking out those pesky errors in the system.",
            "Analyzing logic flows and exception handling for issues.",
            "Deep scan in progress - identifying potential runtime issues."
        ],
        avatar: "https://atarim-wpfeedback-image.s3.eu-west-1.amazonaws.com/images/ai-bots/glitch.png",
    },
    {
        id: 2,
        name: "Pixel reporting for detail duty!",
        comments: [
            "Making sure everything looks pixel-perfect!",
            "Inspecting alignment, spacing, and visual hierarchy.",
            "Checking responsive behavior across different screen sizes.",
            "Examining color consistency and visual accessibility.",
            "Scrutinizing UI elements for proper styling and rendering."
        ],
        avatar: "https://atarim-wpfeedback-image.s3.eu-west-1.amazonaws.com/images/ai-bots/pixel.png",
    },
    {
        id: 3,
        name: "Lexi checking in!",
        comments: [
            "Checking for clarity, tone, and engagement.",
            "Reviewing for consistency and brand voice alignment.",
            "Analyzing readability scores and content structure.",
            "Evaluating content for user engagement opportunities.",
            "Assessing information architecture and content flow."
        ],
        avatar: "https://atarim-wpfeedback-image.s3.eu-west-1.amazonaws.com/images/ai-bots/lexi.png",
    },
    {
        id: 4,
        name: "Navi here. Mapping the journey!",
        comments: [
            "Charting the best path forward – navigation is everything!",
            "Analyzing user flows for intuitive progression and minimal friction.",
            "Evaluating navigation patterns for consistency and usability.",
            "Checking wayfinding elements and information architecture.",
            "Assessing click depths and navigation efficiency."
        ],
        avatar: "https://atarim-wpfeedback-image.s3.eu-west-1.amazonaws.com/images/ai-bots/navi.png",
    },
    {
        id: 5,
        name: "Index here. Sorting the chaos.",
        comments:
            [
                "Scanning structure, unlabeled sections, and anything out of order.",
                "Analyzing content organization and information hierarchy.",
                "Evaluating metadata and content categorization systems.",
                "Checking for logical grouping arrangement of content.",
                "Mapping relationships between different content sections."
            ],
        avatar: "https://atarim-wpfeedback-image.s3.eu-west-1.amazonaws.com/images/ai-bots/index.png",
    },
]

export default function AIBotScanCheckin() {
    const [currentIndex, setCurrentIndex] = useState(0)
    const [currentCommentIndex, setCurrentCommentIndex] = useState(0)
    const intervalRef = useRef<NodeJS.Timeout | null>(null)

    useEffect(() => {
        // Set up the interval
        intervalRef.current = setInterval(() => {
            setCurrentIndex((prevIndex) => {
                const nextIndex = (prevIndex + 1) % feedbackData.length
                setCurrentCommentIndex(Math.floor(Math.random() * feedbackData[nextIndex].comments.length))
                return nextIndex
            })
        }, 4000)
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current)
            }
        }
    }, [])

    const currentFeedback = feedbackData[currentIndex]
    const currentComment = currentFeedback.comments[currentCommentIndex]
    return (
        <div className="w-full max-w-2xl mx-auto p-2 pt-0">
            <AnimatePresence mode="wait">
                <motion.div
                    key={currentFeedback.id}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.3 }}
                    className="flex items-start gap-2"
                >
                    <Avatar className="w-8 h-8 flex-shrink-0" src={currentFeedback.avatar} />
                    <div className="flex min-w-0 gap-1 flex-col">
                        <h3 className="font-semibold text-textcolor text-sm leading-none ">{currentFeedback.name}</h3>
                        <p className="text-textcolor text-sm leading-tight ">
                            {currentComment}
                        </p>

                    </div>
                </motion.div>
            </AnimatePresence>
        </div>
    )
}
